class CustomAddToCart {
  constructor() {
    this.skipModal = false; // flag to bypass modal on simulated click
    this.initializeElements();
    this.attachEventListeners();
    this.createModal();
  }

  initializeElements() {
    // Use a generic selector for add-to-cart buttons in product forms
    this.addToCartButtons = document.querySelectorAll('form[action^="/cart/add"] button[type="submit"]');
    // Select the cart drawer element if it exists
    this.cartDrawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
  }

  createModal() {
    const modalHTML = `
      <div id="custom-cart-modal" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999;">
        <div id="custom-modal-content" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 20px; border-radius: 4px; max-width: 700px; width: 90%;">
          <button type="button" id="close-modal" style="position: absolute; top: 10px; right: 10px; background: transparent; border: none; font-size: 24px; cursor: pointer; color: #666;">&times;</button>
          <h3 style="margin-top: 0; color: rgb(var(--color-foreground)); font-size: 24px; font-weight: bold; text-align: center;">One more thing...</h3>
          <p style="text-align: center; line-height: 150%; color: #323232;">For a more accurate result, please enter your age and gender.</p>
          <form id="custom-info-form">
            <div style="margin-bottom: 15px;">
              <label for="gender" style="display: block; margin-bottom: 8px;">Gender:</label>
              <select id="gender" name="gender" style="width: 100%; padding: 10px; border: 1px solid rgba(var(--color-foreground), 0.3); border-radius: 4px;" required>
                <option value="">Please select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
            <div style="margin-bottom: 5px;">
              <label for="birthdate" style="display: block; margin-bottom: 8px;">Birth Date:</label>
              <input type="date" id="birthdate" name="birthdate" style="width: 100%; padding: 10px; border: 1px solid rgba(var(--color-foreground), 0.3); border-radius: 4px;" required>
              <p style="font-size: 12px; color: #666; margin-top: 5px; letter-spacing: 0;">You need to be at least 18 years old.</p>
            </div>
            <div id="age-error" style="margin-bottom: 10px; color: red; font-size: 14px; letter-spacing: 0; display: none;">You must be at least 18 years old to add to cart.</div>
            <div style="display: flex; justify-content: space-between; gap: 10px;">
              <button type="button" id="cancel-modal" style="flex: 1; padding: 12px 15px; background: transparent; border: 1px solid rgba(var(--color-foreground), 0.3); border-radius: 4px; cursor: pointer;">Cancel</button>
              <button type="submit" id="modal-add-to-cart" style="flex: 1; padding: 12px 15px; background: rgb(var(--color-button)); color: rgb(var(--color-button-text)); border: none; border-radius: 4px; cursor: pointer;">Add to Cart</button>
            </div>
          </form>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('custom-cart-modal');
    this.modalContent = document.getElementById('custom-modal-content');
    this.form = document.getElementById('custom-info-form');
    this.cancelButton = document.getElementById('cancel-modal');
    this.closeButton = document.getElementById('close-modal');
    this.ageError = document.getElementById('age-error');
    this.skipModal = true;
  }

  attachEventListeners() {
    // Listen for clicks on add-to-cart buttons
    this.addToCartButtons.forEach(button => {
      button.addEventListener('click', this.handleAddToCartClick.bind(this));
    });

    // Attach modal events after ensuring elements exist
    setTimeout(() => {
      if (this.cancelButton) {
        this.cancelButton.addEventListener('click', () => {
          this.modal.style.display = 'none';
          this.ageError.style.display = 'none';
        });
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.modal.style.display = 'none';
          this.ageError.style.display = 'none';
        });
      }
      if (this.form) {
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      }
      // Close modal when clicking outside of the modal content
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.modal.style.display = 'none';
          this.ageError.style.display = 'none';
        }
      });
    }, 100);

    // (Optional) Update checkout info on cart/checkout pages
    document.addEventListener('DOMContentLoaded', this.updateCheckoutInfo.bind(this));
    document.addEventListener('cart:refresh', this.updateCheckoutInfo.bind(this));
  }

  handleAddToCartClick(event) {
    // If we're simulating a click, allow default behavior
    if (this.skipModal) return;
    event.preventDefault();
    event.stopPropagation();

    // Store the clicked button and its form
    this.currentButton = event.target.closest('button[type="submit"]');
    this.currentForm = this.currentButton.closest('form');

    // Hide any previous age error message
    this.ageError.style.display = 'none';
    // Show the modal for extra info
    this.modal.style.display = 'block';
  }

  handleFormSubmit(event) {
    event.preventDefault();

    // Retrieve values from modal inputs
    const gender = document.getElementById('gender').value;
    const birthdate = document.getElementById('birthdate').value;

    // Validate age: must be at least 18 years old
    const today = new Date();
    const birthDate = new Date(birthdate);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age < 18) {
      // Instead of alert, display an error message above the buttons
      this.ageError.style.display = 'block';
      return;
    }

    // Save values for persistence
    localStorage.setItem('customer_gender', gender);
    localStorage.setItem('customer_birthdate', birthdate);

    // Append hidden fields with the additional info to the product form
    let genderInput = this.currentForm.querySelector('input[name="properties[Gender]"]');
    let birthdateInput = this.currentForm.querySelector('input[name="properties[Birth Date]"]');
    if (!genderInput) {
      genderInput = document.createElement('input');
      genderInput.type = 'hidden';
      genderInput.name = 'properties[Gender]';
      this.currentForm.appendChild(genderInput);
    }
    if (!birthdateInput) {
      birthdateInput = document.createElement('input');
      birthdateInput.type = 'hidden';
      birthdateInput.name = 'properties[Birth Date]';
      this.currentForm.appendChild(birthdateInput);
    }
    genderInput.value = gender;
    birthdateInput.value = birthdate;

    // Hide the modal and reset error message if any
    this.modal.style.display = 'none';
    this.ageError.style.display = 'none';

    // Set flag to bypass modal on the next click and simulate a click on the original button
    this.skipModal = true;
    this.currentButton.click();
    // Reset the flag shortly after so future user clicks still show the modal
    setTimeout(() => {
      this.skipModal = false;
    }, 100);
  }

  updateCheckoutInfo() {
    // (Optional) Update extra checkout info on cart/checkout pages
    if (window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout')) {
      const gender = localStorage.getItem('customer_gender');
      const birthdate = localStorage.getItem('customer_birthdate');
      if (window.Shopify && Shopify.Checkout) {
        const orderSummary = document.querySelector('.order-summary__sections');
        if (orderSummary && (gender || birthdate)) {
          let customInfoDiv = document.getElementById('custom-user-info');
          if (!customInfoDiv) {
            customInfoDiv = document.createElement('div');
            customInfoDiv.id = 'custom-user-info';
            customInfoDiv.className = 'order-summary__section';
            customInfoDiv.innerHTML = `
              <div class="order-summary__section__content">
                <h3>Additional Information</h3>
                <table class="product-table">
                  <tbody id="custom-info-table"></tbody>
                </table>
              </div>
            `;
            orderSummary.appendChild(customInfoDiv);
          }
          const infoTable = document.getElementById('custom-info-table');
          infoTable.innerHTML = `
            ${gender ? `<tr><th>Gender:</th><td>${gender}</td></tr>` : ''}
            ${birthdate ? `<tr><th>Birth Date:</th><td>${birthdate}</td></tr>` : ''}
          `;
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new CustomAddToCart();
});

// Optional: Additional checkout page functionality if needed
if (window.Shopify && Shopify.Checkout) {
  document.addEventListener('page:load page:change', function() {
    const gender = localStorage.getItem('customer_gender');
    const birthdate = localStorage.getItem('customer_birthdate');
    if (gender || birthdate) {
      setTimeout(function() {
        const orderSummary = document.querySelector('.order-summary__sections');
        if (orderSummary) {
          let customInfoDiv = document.getElementById('custom-user-info');
          if (!customInfoDiv) {
            customInfoDiv = document.createElement('div');
            customInfoDiv.id = 'custom-user-info';
            customInfoDiv.className = 'order-summary__section';
            customInfoDiv.innerHTML = `
              <div class="order-summary__section__content">
                <h3>Additional Information</h3>
                <table class="product-table">
                  <tbody>
                    ${gender ? `<tr><th>Gender:</th><td>${gender}</td></tr>` : ''}
                    ${birthdate ? `<tr><th>Birth Date:</th><td>${birthdate}</td></tr>` : ''}
                  </tbody>
                </table>
              </div>
            `;
            orderSummary.appendChild(customInfoDiv);
          }
        }
      }, 1000);
    }
  });
}
